import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Switch, Button, message, Typography } from 'antd';
import { MessageOutlined, SaveOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

const API_BASE = process.env.NODE_ENV === 'production' ? '' : (process.env.REACT_APP_API_URL || 'http://localhost:18080');

const SmsConfig = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => { fetchConfig(); }, []);

  const fetchConfig = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('admin_token');
      const res = await fetch(`${API_BASE}/api/admin/configs`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.code === 0) {
        const map = {};
        (data.data.list || []).forEach(c => { map[c.config_key] = c.config_value; });
        form.setFieldsValue({
          sms_enabled: map.sms_enabled === 'true',
          sms_username: map.sms_username || '',
          sms_password: map.sms_password || '',
          sms_template: map.sms_template || '',
        });
      }
    } catch (e) { message.error('加载失败'); }
    setLoading(false);
  };

  const handleSave = async (values) => {
    setSaving(true);
    try {
      const token = localStorage.getItem('admin_token');
      const configs = [
        { key: 'sms_enabled', value: String(values.sms_enabled || false) },
        { key: 'sms_username', value: values.sms_username || '' },
        { key: 'sms_password', value: values.sms_password || '' },
        { key: 'sms_template', value: values.sms_template || '' },
      ];
      for (const c of configs) {
        await fetch(`${API_BASE}/api/admin/configs/key/${c.key}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ config_value: c.value })
        });
      }
      message.success('保存成功');
    } catch (e) { message.error('保存失败'); }
    setSaving(false);
  };

  return (
    <div>
      <Title level={4}><MessageOutlined style={{ marginRight: 8 }} />短信配置</Title>
      <Card loading={loading}>
        <Form form={form} layout="vertical" onFinish={handleSave}>
          <Form.Item name="sms_enabled" label="启用短信" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item name="sms_username" label="短信宝用户名"
            rules={[{ required: true, message: '请输入短信宝用户名' }]}>
            <Input placeholder="短信宝注册用户名" />
          </Form.Item>
          <Form.Item name="sms_password" label="短信宝密码（明文）"
            extra="输入明文密码，发送短信时系统自动转为MD5"
            rules={[{ required: true, message: '请输入短信宝密码' }]}>
            <Input.Password placeholder="密码明文，系统会自动MD5" />
          </Form.Item>
          <Form.Item name="sms_template" label="短信模板"
            extra="变量：{yue}=当前余额 {fazhi}=预警阈值"
            rules={[{ required: true, message: '请输入短信模板' }]}>
            <Input.TextArea rows={2} placeholder='【汕头市睿铤科技】您的账户余额不足 {yue}，已低于预警值 {fazhi}，请及时充值以免影响业务。' />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<SaveOutlined />} loading={saving}>
              保存
            </Button>
          </Form.Item>
        </Form>
        <Text type="secondary">
          短信宝注册地址：<a href="https://www.smsbao.com" target="_blank" rel="noreferrer">https://www.smsbao.com</a>
          ，短信接口文档：<a href="https://www.smsbao.com/openapi/213.html" target="_blank" rel="noreferrer">查看文档</a>
        </Text>
      </Card>
    </div>
  );
};

export default SmsConfig;
